import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  triggerGetMe: false,
  currentUser: null,
};

const meSlice = createSlice({
  name: 'me',
  initialState,
  reducers: {
    setMe: (state, action) => {
      state.currentUser = action.payload;
      return state;
    },
    setTriggerGetMe: (state, action) => {
      state.triggerGetMe = action.payload;
      return state;
    },
  },
});

export const { setMe, setTriggerGetMe } = meSlice.actions;

export default meSlice.reducer;
